import script from "./currentWeekIncineratedChart.vue?vue&type=script&setup=true&lang=js"
export * from "./currentWeekIncineratedChart.vue?vue&type=script&setup=true&lang=js"

import "./currentWeekIncineratedChart.vue?vue&type=style&index=0&id=0a743908&lang=css"

const __exports__ = script;

export default __exports__